function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

import { DataCampLogo, DataCampLogomark } from '@datacamp/waffles/brand';
import { Button } from '@datacamp/waffles/button';
import { Tooltip } from '@datacamp/waffles/tooltip';
import React from 'react';
import { config } from './config';
import { jsx as ___EmotionJSX } from "@emotion/react";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "19lbh5u",
  styles: "padding-left:6px;padding-right:6px"
} : {
  name: "184gm5r-logoButton",
  styles: "padding-left:6px;padding-right:6px;label:logoButton;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9Mb2dvLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF1Qk0iLCJmaWxlIjoiLi4vc3JjL0xvZ28udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgRGF0YUNhbXBMb2dvLCBEYXRhQ2FtcExvZ29tYXJrIH0gZnJvbSAnQGRhdGFjYW1wL3dhZmZsZXMvYnJhbmQnO1xuaW1wb3J0IHsgQnV0dG9uIH0gZnJvbSAnQGRhdGFjYW1wL3dhZmZsZXMvYnV0dG9uJztcbmltcG9ydCB7IFRvb2x0aXAgfSBmcm9tICdAZGF0YWNhbXAvd2FmZmxlcy90b29sdGlwJztcbmltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7IGNvbmZpZyB9IGZyb20gJy4vY29uZmlnJztcblxudHlwZSBMb2dvUHJvcHMgPSB7XG4gIG9uQ2xpY2s/OiAoKSA9PiB2b2lkO1xuICBzbWFsbD86IGJvb2xlYW47XG4gIHRvb2x0aXA/OiBzdHJpbmc7XG59O1xuXG5leHBvcnQgY29uc3QgTG9nbzogUmVhY3QuRkM8TG9nb1Byb3BzPiA9ICh7XG4gIG9uQ2xpY2ssXG4gIHNtYWxsID0gZmFsc2UsXG4gIHRvb2x0aXAsXG59KSA9PiB7XG4gIGNvbnN0IGxvZ29CdXR0b24gPSAoXG4gICAgPEJ1dHRvblxuICAgICAgYXJpYS1sYWJlbD1cImxhbmRpbmdcIlxuICAgICAgYXM9XCJhXCJcbiAgICAgIGNsYXNzTmFtZT1cImFscGEtbmF2YmFyLWxvZ29cIlxuICAgICAgY3NzPXt7IHBhZGRpbmdMZWZ0OiA2LCBwYWRkaW5nUmlnaHQ6IDYgfX1cbiAgICAgIGRhdGEtY3k9XCJoZWFkZXItbG9nb1wiXG4gICAgICBkYXRhLXRlc3RpZD1cImFscGEtbmF2YmFyLWxvZ29cIlxuICAgICAgZGF0YS10cmFja2lkPVwiYWxwYS1uYXZiYXItbG9nb1wiXG4gICAgICBocmVmPXtvbkNsaWNrID8gdW5kZWZpbmVkIDogY29uZmlnLmRhdGFjYW1wX3VybH1cbiAgICAgIG9uQ2xpY2s9e29uQ2xpY2t9XG4gICAgICB2YXJpYW50PVwicGxhaW5cIlxuICAgID5cbiAgICAgIHtzbWFsbCA/IChcbiAgICAgICAgPERhdGFDYW1wTG9nb21hcmsgaGVpZ2h0PVwiMjhcIiBtb25vY2hyb21lIC8+XG4gICAgICApIDogKFxuICAgICAgICA8RGF0YUNhbXBMb2dvIGhlaWdodD1cIjI4XCIgbW9ub2Nocm9tZSAvPlxuICAgICAgKX1cbiAgICA8L0J1dHRvbj5cbiAgKTtcbiAgaWYgKHRvb2x0aXApIHtcbiAgICByZXR1cm4gKFxuICAgICAgPFRvb2x0aXAgY29udGVudD17dG9vbHRpcH0gcGxhY2VtZW50PVwiYm90dG9tTGVmdFwiPlxuICAgICAgICB7bG9nb0J1dHRvbn1cbiAgICAgIDwvVG9vbHRpcD5cbiAgICApO1xuICB9XG4gIHJldHVybiBsb2dvQnV0dG9uO1xufTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

export var Logo = function Logo(_ref) {
  var onClick = _ref.onClick,
      _ref$small = _ref.small,
      small = _ref$small === void 0 ? false : _ref$small,
      tooltip = _ref.tooltip;

  var logoButton = ___EmotionJSX(Button, {
    "aria-label": "landing",
    as: "a",
    className: "alpa-navbar-logo",
    css: _ref2,
    "data-cy": "header-logo",
    "data-testid": "alpa-navbar-logo",
    "data-trackid": "alpa-navbar-logo",
    href: onClick ? undefined : config.datacamp_url,
    onClick: onClick,
    variant: "plain"
  }, small ? ___EmotionJSX(DataCampLogomark, {
    height: "28",
    monochrome: true
  }) : ___EmotionJSX(DataCampLogo, {
    height: "28",
    monochrome: true
  }));

  if (tooltip) {
    return ___EmotionJSX(Tooltip, {
      content: tooltip,
      placement: "bottomLeft"
    }, logoButton);
  }

  return logoButton;
};